import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function OtherRecordsTextarea() {
  return (
    <Field
      type="textarea"
      name="otherRecords"
      label={i18n.t('entity.vehicle.labels.otherRecords')}
      minRows={1}
      maxRows={25}
      isScrollable
      isResizable
    />
  );
}
